"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_dom_1 = require("react-router-dom");
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var data_1 = require("utils/selectors/data");
var RedirectServiceId = function () {
    var serviceId = (0, react_router_dom_1.useParams)().serviceId;
    var servicesMap = (0, react_redux_1.useSelector)(data_1.selectServicesMap);
    if (!(0, react_redux_firebase_1.isLoaded)(servicesMap)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var service = servicesMap === null || servicesMap === void 0 ? void 0 : servicesMap[serviceId];
    if (!service) {
        return (0, jsx_runtime_1.jsx)("div", { children: "Missing Service" });
    }
    var location = window.location;
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.Redirect, { to: "/tools/".concat(service.metaCategoryId, "/").concat(service.slug).concat(location.search).concat(location.hash) });
};
exports.default = RedirectServiceId;
